module.exports = __webpack_public_path__ + "bg_bar.91a3598e.gif";